import script from "./PCPartsDetailsChangeDatePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsDetailsChangeDatePopup.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsDetailsChangeDatePopup.vue?vue&type=style&index=0&id=70e5768f&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70e5768f"]])

export default __exports__